export default __webpack_public_path__ + "static/media/drag-drop.f8150946.svg";